module.exports = __webpack_public_path__ + "img/position-pointer.9e75e073.svg";